export const mutation_startSignSession = `
mutation startSignSession($dataInput: StartSignSessionInput!) {
    startSignSession(dataInput: $dataInput) {
        allegatoId
        hubId
        signUrl
        batchId
    }
}`;
export const mutation_pollSessionStatus = `
mutation pollSessionStatus($tenantId: String!, $aziendaId: Int!) {
    pollSessionStatus(tenantId: $tenantId, aziendaId: $aziendaId) {
        totalPending
        updatedCount
        errorCount
        stillPendingCount
    }
}`;
export const mutation_postToArchive = `
mutation postToArchive($dataInput: PostToArchiveInput!) {
    postToArchive(dataInput: $dataInput) {
        allegatoId
        cctId
    }
}`;